
	import { Component, Prop, Vue } from 'vue-property-decorator';

	@Component({
		name: 'DownloadUsbAgent'
	})
	export default class DownloadUsbAgent extends Vue {
		mounted() {
			window.location.href = window.appConfig.VUE_APP_USB_AGENT_DOWNLOAD_URL;
		}
		download() {
			window.location.href = window.appConfig.VUE_APP_USB_AGENT_DOWNLOAD_URL;
		}
	}
